<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
      <app-content-header [contentHeader]="contentHeader"></app-content-header>
  
      <section id="change-password">
        <div class="card-container">
            <div class="card">
                <div class="row">
                    <div class="col-6">
                        <div class="card-body">
                            <form
                      class="auth-reset-pass-form mt-2"
                      [formGroup]="changePasswordForm"
                      (ngSubmit)="onSubmit()"
                    >
                      <div class="form-group col-12">
                        <label for="currentPassword">Current Password</label>
                       
                            <div
                              class="input-group input-group-merge form-password-toggle"
                            >
                              <input
                                [type]="isOldPasswordHidden ? 'text' : 'password'"
                                class="form-control form-control-merge"
                                formControlName="currentPassword"
                                id="currentPassword"
                                tabindex="1"
                                [ngClass]="{ 'is-invalid error': submitted && f.currentPassword.errors }"
                                
                              />

                              <div class="input-group-append">
                                <span class="input-group-text cursor-pointer">
                                  <i
                                    class="feather font-small-4"
                                    [ngClass]="{
                                      'icon-eye-off': isOldPasswordHidden,
                                      'icon-eye': !isOldPasswordHidden
                                    }"
                                    (click)="hideUnhideOldPassword()"
                                  >
                                  </i>
                                </span>
                              </div>
                            </div>
                            <div
                *ngIf="submitted && f.currentPassword.errors"
                class="invalid-feedback"
                [ngClass]="{ 'd-block': submitted && f.currentPassword.errors }"
              >
                <div *ngIf="f.currentPassword.errors.required">Current password is required</div>
              </div>
                          </div>

                          <div class="form-group col-12">
                        <label for="password">New Password</label>

                       
                            <div
                              class="input-group input-group-merge form-password-toggle"
                            >
                              <input
                                [type]="isNewPasswordHidden ? 'text' : 'password'"
                                class="form-control form-control-merge"
                                formControlName="password"
                                id="password"
                                tabindex="2"
                                aria-describedby="password"
                                [ngClass]="{ 'is-invalid error': submitted && f.password.errors }"
                              />

                              <div class="input-group-append">
                                <span class="input-group-text cursor-pointer">
                                  <i
                                    class="feather font-small-4"
                                    [ngClass]="{
                                      'icon-eye-off': isNewPasswordHidden,
                                      'icon-eye': !isNewPasswordHidden
                                    }"
                                    (click)="hideUnhideNewPassword()"
                                  >
                                  </i>
                                </span>
                              </div>


                              
                            </div>                              

                        <div
                        *ngIf="submitted && f.password.errors"
                        class="invalid-feedback"
                        [ngClass]="{ 'd-block': submitted && f.password.errors }"
                      >
                        <div *ngIf="f.password.errors.required">New password is required</div>
                      </div>
                    </div>

                    <div class="form-group col-12">
                        <label for="confirmPassword">Confirm Password</label>
                       
                            <div
                              class="input-group input-group-merge form-password-toggle"
                            >
                              <input
                                [type]="
                                  isConfirmPasswordHidden ? 'text' : 'password'
                                "
                                class="form-control form-control-merge"
                                formControlName="confirmPassword"
                                id="confirmPassword"
                                tabindex="3"
                                [ngClass]="{ 'is-invalid error': submitted && f.confirmPassword.errors }"
                              />

                              <div class="input-group-append">
                                <span class="input-group-text cursor-pointer">
                                  <i
                                    class="feather font-small-4"
                                    [ngClass]="{
                                      'icon-eye-off': isConfirmPasswordHidden,
                                      'icon-eye': !isConfirmPasswordHidden
                                    }"
                                    (click)="hideUnhideConfirmPassword()"
                                  >
                                  </i>
                                </span>
                              </div>
                            </div>
                          <div
                *ngIf="submitted && f.confirmPassword.errors"
                class="invalid-feedback"
                [ngClass]="{ 'd-block': submitted && f.confirmPassword.errors }"
              >
                <div *ngIf="f.confirmPassword.errors.required">Confirm password is required</div>
                <div *ngIf="f.confirmPassword.errors.mustMatch">Password did not match</div>
              </div>
                      </div>

                      
                        <div class="col-12">
                          <button
                          style="margin-bottom: 10px !important"
                          tabindex="4"
                            class="btn btn-primary btn-block"
                            rippleEffect
                          >
                            Change Password
                          </button>
                      
                      </div>
                    </form>
                        </div>
                    </div>

                    <!-- <div class="vertical-rule"></div> -->

                    <div class="col-6">
                        <div class="card-body" style="margin-top:10px">
                            <p class="d-block">Password requirements:</p>
                        <ul>
                          <li
                            class="mb-30 password-requirement"
                            [class.password-invalid]="
                              submitted && f.password.errors?.characterLength
                            "
                            [class.password-valid]="
                              submitted && !f.password.errors?.characterLength
                            "
                          >
                            Minimum 8 characters long
                          </li>
                          <li
                            class="mb-30 password-requirement"
                            [class.password-invalid]="
                              submitted && f.password.errors?.lowerCase
                            "
                            [class.password-valid]="
                              submitted && !f.password.errors?.lowerCase
                            "
                          >
                            At least one lowercase character
                          </li>
                          <li
                            class="mb-30 password-requirement"
                            [class.password-invalid]="
                              submitted && f.password.errors?.upperCase
                            "
                            [class.password-valid]="
                              submitted && !f.password.errors?.upperCase
                            "
                          >
                            At least one uppercase character
                          </li>
                          <li
                            class="mb-30 password-requirement"
                            [class.password-invalid]="
                              submitted && f.password.errors?.number
                            "
                            [class.password-valid]="
                              submitted && !f.password.errors?.number
                            "
                          >
                            At least one number
                          </li>
                        </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </section>
    </div>
  </div>
  